<template>
  <div>
    <b-row v-show="iswin">
      <b-col cols="3">
        <el-menu :default-active="defaultId" class="el-menu-vertical-demo" text-color="#fff" background-color="#002d71" active-text-color="#FBC52C" @select="handleSelect">
          <template v-for="item in items">
            <template>
              <el-menu-item :index="item.id + ''" :key="item.id">
                <span slot="title" class="MenuTxT">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </b-col>
      <b-col cols="9">
        <el-card>
          <div v-html="content"></div>
        </el-card>
      </b-col>
    </b-row>
    <b-row v-show="isMo">
      <b-col>
        <el-menu :default-active="defaultId" class="el-menu-vertical-demo" text-color="#fff" background-color="#002d71" active-text-color="#FBC52C" @select="handleSelect" mode="horizontal">
          <template v-for="item in items">
            <template>
              <el-menu-item :index="item.id + ''" :key="item.id">
                <span slot="title" class="menuTxT">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
        <el-card>
          <div v-html="content"></div>
        </el-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  data() {
    return {
      content: "",
      requestUrl: {
        baseUrl: "/article",
      },
      defaultId: "",
      iswin: true,
      inMo: false,
    };
  },
  props: ["items"],
  created() {
    if (this.items.length) {
      this.defaultId = this.items[0].id + "";
      this.handleSelect(this.defaultId);
    }
  },
  mounted() {
    this.checkWindowWidth(); // 初始化时检查窗口大小
    window.addEventListener("resize", this.checkWindowWidth); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkWindowWidth); // 在组件销毁前移除事件监听
  },
  methods: {
    checkWindowWidth() {
      if (window.innerWidth > 1000) {
        this.iswin = true;
        this.isMo = false;
      } else {
        this.iswin = false;
        this.isMo = true;
      }
    },
    handleSelect(key) {
      this.getContent(key);
    },
    getContent(id) {
      request.get(this.requestUrl.baseUrl + "/" + id).then((res) => {
        if (res.code === "200") {
          this.content = res.data.content;
        }
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 1000px) {
  .menuTxT {
    font-size: medium;
    font-weight: bold;
  }
}

@media (min-width: 770px) and (max-width: 1205px) {
  .MenuTxT {
    font-size: large;
  }
}

@media (min-width: 1205px) {
  .MenuTxT {
    font-size: large;
  }
}

.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}
.sidebar > ul {
  height: 100%;
}
</style>
